export interface ColumnConfig {
  id: string;
  label: string;
  visible: boolean;
}

export const DEFAULT_COMPLIANCE_ASSETS_COLUMNS: ColumnConfig[] = [
  { id: 'select', label: 'Select', visible: true },
  { id: 'assetName', label: 'Asset Name', visible: true },
  { id: 'category', label: 'Category', visible: true },
  { id: 'location', label: 'Location', visible: true },
  { id: 'regimeName', label: 'Regulation', visible: true },
  { id: 'requirementName', label: 'Requirement', visible: false },
  { id: 'lastEventDate', label: 'Last Check', visible: false },
  { id: 'nextDueDate', label: 'Next Due', visible: true },
  { id: 'status', label: 'Status', visible: true },
  { id: 'riskBand', label: 'Risk Band', visible: false },
  { id: 'assignedTo', label: 'Assigned To', visible: false },
  { id: 'lastResult', label: 'Last Result', visible: false },
  { id: 'contractor', label: 'Contractor', visible: false },
];
